module.exports = __webpack_public_path__ + "img/v1.b5eab0f1.jpg";